module.exports = __webpack_public_path__ + "static/img/img-demand.ea3ecc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-demand.png
// module id = 52T7
// module chunks = 0